// src/AmplifyProvider.js
import React from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import awsExports from './aws-exports'; // パスを確認してください
import '@aws-amplify/ui-react/styles.css';

// Amplifyの設定
Amplify.configure({ ...awsExports });

const AmplifyProvider = ({ children }) => {
  return (
    <Authenticator.Provider>
      {children}
    </Authenticator.Provider>
  );
};

export default AmplifyProvider;
